import { Component, Input } from '@angular/core';
import { GaMessageService } from '../../../../shared/message/ga-message.service';
import { GA1Service } from '../../../../shared/ga1/ga1.service';
import { IDocumentGroup, IOrderEntryDocument } from '../documents/order-entry-documents-data.service';
import * as _ from 'underscore';
import { OrderEntryDocumentsService } from '../documents/order-entry-documents.service';
import { OrderEntryWebshopService } from '../webshop/order-entry-webshop.service';
import { OrderEntryService } from '../order-entry.service';

@Component({
  selector: 'confirm-tc-label',
  template: `
    <span class="label-text" [class.req]="isRequired">
      <span translate>ORDERENTRY.CONFIRM.TC</span>: <a (click)="showACSLTC($event)">ACSL T&C</a>,
      <a (click)="goToLocalTC($event)">Local T&C</a>&nbsp;
      <span translate *ngIf="!hidePrices">GA.GENERAL.AND</span>&nbsp;
      <a (click)="showBillingTypeImplications($event)" *ngIf="!hidePrices"><span translate>ORDERENTRY.CONFIRM.BILLING_TYPE_IMPLICATIONS</span></a>
    </span>
  `
})
export class ConfirmTcLabelComponent {
  @Input() public isRequired:boolean;
  @Input() public hidePrices:boolean;

  constructor(
    private messageService:GaMessageService,
    private orderEntryDocumentsService:OrderEntryDocumentsService,
    private orderEntryWebshopService:OrderEntryWebshopService,
    private orderEntryService:OrderEntryService,
    private ga1Service:GA1Service
  ) {
    /**/
  }

  public showACSLTC(event:Event):void {
    event.preventDefault();
    this.messageService.showGA1Dialog('ORDERENTRY.CONFIRM.ACSL_TC', this.ga1Service.getGA1Url(GA1Service.URLTYPE_ACSL_TC));
  }

  public goToLocalTC(event:Event):void {
    event.preventDefault();
    const localCaveats:IDocumentGroup = _.findWhere(this.orderEntryDocumentsService.documents, { typeCode: 'LOCAL_TC' });
    let title:string;
    let message:string;

    // documents are still loading
    if (!this.orderEntryDocumentsService.documents.length) {
      title = 'ORDERENTRY.CONFIRM.DOCS_LOADING_TITLE';
      message = 'ORDERENTRY.CONFIRM.DOCS_LOADING_MESSAGE';
      this.messageService.showMessageDialog(title, message);
    } else {
      if (localCaveats && (localCaveats.comment || localCaveats.documents?.length)) {
        this.showTCMessage('Local T&C', localCaveats);
      } else {
        title = 'ORDERENTRY.CONFIRM.LOCAL_TC_TITLE';
        message = 'ORDERENTRY.CONFIRM.LOCAL_TC_MESSAGE';
        this.messageService.showMessageDialog(title, message);
      }
    }
  }

  public showBillingTypeImplications(event:Event):void {
    event.preventDefault();
    this.messageService.showGA1Dialog('ORDERENTRY.CONFIRM.BILLING_TYPE_IMPLICATIONS', this.ga1Service.getGA1Url(GA1Service.URLTYPE_BILLING_TYPE));
  }

  public showTCMessage(title:string, localCaveats:IDocumentGroup):void {
    let message = localCaveats.comment? `<p class="local-tc-comment">${localCaveats.comment}</p>` : '';

    for (let i = 0; localCaveats.documents && i < localCaveats.documents.length; i++) {
      const doc:IOrderEntryDocument = localCaveats.documents[ i ];
      const url:string = this.orderEntryDocumentsService.getDocumentUrl(doc, undefined, this.orderEntryService.orderNumber);
      message += `<p class="local-tc-file"><a class="document-link" href="${url}" target="_blank"><i class="fa fa-download"></i> ${doc.name} </a></p>`;
    }

    this.messageService.showMessageDialog(title, message);
  }
}